import { Component, OnInit } from '@angular/core';
import { HttpService } from '../../services/http.service';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { SettingsService } from '../../services/settings.service';
import { filter } from 'rxjs/operators';

@Component({
  selector: 'app-settings',
  templateUrl: './settings.component.html',
  styleUrls: ['./settings.component.scss']
})
export class SettingsComponent implements OnInit {

  processing = true;
  form = new FormGroup({
    SetAnswerWaitTime: new FormControl('', Validators.required),
    SetAttemptsDelay: new FormControl('', Validators.required),
    SetMaxAttempts: new FormControl('', Validators.required),
  })

  constructor(private settingsService: SettingsService) {}

  ngOnInit(): void {
    this.settingsService.init();
    this.settingsService.settings$.pipe(filter(x => !!x)).subscribe(x => {
      this.form.controls.SetAnswerWaitTime.setValue(x?.SetAnswerWaitTime);
      this.form.controls.SetAttemptsDelay.setValue(x?.SetAttemptsDelay);
      this.form.controls.SetMaxAttempts.setValue(x?.SetMaxAttempts);
      this.processing = false;
    })
  }

  save() {
    if (this.form.invalid) {
      return;
    }
    this.processing = true;
    const data = this.form.getRawValue();
    /*this.settingsService.setSettings(data).subscribe(x => {
      this.form.controls.SetAnswerWaitTime.setValue(x.SetAnswerWaitTime);
      this.form.controls.SetAttemptsDelay.setValue(x.SetAttemptsDelay);
      this.form.controls.SetMaxAttempts.setValue(x.SetMaxAttempts);
      this.processing = false;
    }, error => {
      // обработка ошибки
      this.processing = false;
    });*/
  }
}
